import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Permission } from '@/types'
import { api } from '@api/client'

interface AuthState {
  isAuthenticated: boolean
  permission: Permission | null
  tokenName: string | null
  tokenId: number | null
  login: (apiToken: string) => Promise<boolean>
  logout: () => Promise<void>
  checkSession: () => Promise<boolean>
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, _get) => ({
      isAuthenticated: false,
      permission: null,
      tokenName: null,
      tokenId: null,

      login: async (apiToken: string) => {
        try {
          const response = await api.auth.login(apiToken)
          if (response.success) {
            set({
              isAuthenticated: true,
              permission: response.permission,
              tokenName: response.tokenName,
              tokenId: response.tokenId,
            })
            return true
          }
          return false
        } catch {
          return false
        }
      },

      logout: async () => {
        try {
          await api.auth.logout()
        } finally {
          set({
            isAuthenticated: false,
            permission: null,
            tokenName: null,
            tokenId: null,
          })
        }
      },

      checkSession: async () => {
        try {
          const session = await api.auth.getSession()
          set({
            isAuthenticated: true,
            permission: session.permission,
            tokenName: session.tokenName,
            tokenId: session.tokenId,
          })
          return true
        } catch {
          set({
            isAuthenticated: false,
            permission: null,
            tokenName: null,
            tokenId: null,
          })
          return false
        }
      },
    }),
    {
      name: 'sportsmeld-auth',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        permission: state.permission,
        tokenName: state.tokenName,
        tokenId: state.tokenId,
      }),
    }
  )
)
